import React, { FunctionComponent } from 'react'
import { DesignLanguage, Text, useIsDesignLanguage } from '@afterpaytouch/core'
import { AppLink } from '../../AppLink'
import { setMobileLoginVerifiedRoute, useAppDispatch, useMobileLogin } from '../../../state'
import { Route } from '../../../config/router'
import styles from '../styles.module.css'
import { TrackingEvent } from '../../../model'
import { useCheckoutSizes } from '../../../utils/responsive'
import { useTranslation } from '../../../utils/convergence'

export const ForgotPasswordLink: FunctionComponent = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const { textSize } = useCheckoutSizes()
  const { isMobileLogin, dateOfBirthVerificationRequired } = useMobileLogin()
  const isMobileLoginVerificationRequired = isMobileLogin && dateOfBirthVerificationRequired
  const onClickForgotPasswordLink = (): void => {
    if (isMobileLoginVerificationRequired) {
      dispatch(setMobileLoginVerifiedRoute(Route.VERIFY))
    }
  }

  return (
    <div onClick={onClickForgotPasswordLink} className={styles.inlineLink}>
      <AppLink
        underline
        center
        noMargin
        route={isMobileLoginVerificationRequired ? Route.VERIFY_CHALLENGE : Route.VERIFY}
        trackEventName={TrackingEvent.PRESSED_FORGOT_PASSWORD}
      >
        <Text bold size={textSize} testNameSpace='forgot-password' color={isArcadeDesignLanguage ? 'Inverse Dark' : undefined}>
          {t('password:forgotPassword')}
        </Text>
      </AppLink>
    </div>
  )
}
